export const getCookie = (name: string) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  if (match) return match[2];
  return '';
};

export const setCookie30sec = (name: string) => {
  const expires = new Date(Date.now() + 30000).toUTCString();
  document.cookie = `${name}=${name}; expires=${expires};path=/;`;
};
export const setCookie1sec = (name: string) => {
  const expires = new Date(Date.now() + 1000).toUTCString();
  document.cookie = `${name}=${name}; expires=${expires};path=/;`;
};
export const setCookie = (name: string, value: string) => {
  const twoDaysInMilliseconds = 2 * 24 * 60 * 60 * 1000; // 2 days in milliseconds
  const expires = new Date(Date.now() + twoDaysInMilliseconds).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires};path=/; SameSite=Strict;`;
};
